<template>
  <div class="location-wrap">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.project_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('locationBizExport', {...formSearch,excludeColumnList:timeZoneList.length>1?[]:['timeZoneRegionDesc']})">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right;" :class="{ 'mr-0': !funcView.project_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item v-if="funcView.project_add">
          <el-button type="primary" icon="el-icon-plus" @click="addProject()">{{ $t('Common.com_add') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.project_update_targets">
          <el-button type="primary" :disabled="!hasBasicGoal" @click="onUpdateTargets()">{{ funcView.project_update_targets }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.project_update_timeZone &&timeZoneList.length>1">
          <el-button type="primary" :disabled="!this.tableSelect.length" @click="onUpdateTimeZone()">{{ $t('dms_location.tbxmsq') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.project_enable_target_autoset">
          <el-button type="primary" :disabled="!hasNoBasicGoa" @click="onEnableTargets()">{{ $t('dms_location.qymbzdsz') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.project_disable_target_autoset">
          <el-button type="primary" :disabled="!hasBasicGoal" @click="onDisableTargets()">{{ $t('dms_location.jymbzdsz') }}</el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_location.xiang_mu_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <template>
          <!-- 创建时间 -->
          <el-form-item :label="$t('dms_location.chuang_jian_shi_jian')">
            <custom-date-picker
              style="width: 100%"
              v-model="formSearch.gmtCreate"
              type="daterange"
              align="right"
              value-format="YYYY-MM-DD HH:mm:ss"
              clearable
              :picker-options="beforeToday"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_location.suo_shu_gong_si')">
            <el-input
              v-model="formSearch.orgName"
              clearable
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
    </switch-container>

    <div class="table-bd">
      <custom-table-expand
        type="checkbox"
        v-model="tableSelect"
        :rowId="getRowKeys"
        v-if="isInch"
        tableCode="locationManage_ft"
        :data="locationList"
        @filter="filterChange"
        :filterArr="timeZoneList.length>1?[]:['timeZoneRegionDesc']"
        @sort="sortChange"
        height="100%"
        @column="setColumn"
        :slots="['expand','deviceNum', 'goalArea','goalTime','detailAddress', 'action']"
        index
        @exChange="exChange"
        expand-row-keys
        expand
        :expandsKeyList="expands"
      >
        <template v-slot:deviceNum="scope">
          <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
          <span v-else type="text">{{ scope.row.deviceNum }}</span>
        </template>
        <template v-slot:goalArea="scope">
          <el-popover placement="bottom" width="610" trigger="hover" v-if="+scope.row.goalArea>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
            <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
              <el-table-column width="100" property="productCode" :label="$t('dms_location.chan_pin_xing_hao')"></el-table-column>
              <el-table-column width="70" property="deviceNum" :label="$t('dms_location.she_bei_shu_liang')"></el-table-column>
              <el-table-column width="100" property="basicArea" :label="$t('dms_location.xttjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?$formatLenLocal(+scope.row.basicArea):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="basicTime" :label="$t('dms_location.xttjqjscmint')"></el-table-column>
              <el-table-column width="100" property="totalGoalArea" :label="$t('dms_location.xjqjmjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="totalGoalTime" :label="$t('dms_location.xjqjscmint')">
                <template slot-scope="scope">
                  <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference" class="cell-link">{{ $formatLenLocal(scope.row.goalArea) }}</span>
          </el-popover>
          <span  v-else >{{$formatLenLocal(scope.row.goalArea)}}</span>
        </template>
        <template v-slot:goalTime="scope">
          <el-popover placement="bottom" width="610" trigger="hover" v-if="+scope.row.goalTime>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
            <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
              <el-table-column width="100" property="productCode" :label="$t('dms_location.chan_pin_xing_hao')"></el-table-column>
              <el-table-column width="70" property="deviceNum" :label="$t('dms_location.she_bei_shu_liang')"></el-table-column>
              <el-table-column width="100" property="basicArea" :label="$t('dms_location.xttjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?$formatLenLocal(+scope.row.basicArea):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="basicTime" :label="$t('dms_location.xttjqjscmint')"></el-table-column>
              <el-table-column width="100" property="totalGoalArea" :label="$t('dms_location.xjqjmjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="totalGoalTime" :label="$t('dms_location.xjqjscmint')">
                <template slot-scope="scope">
                  <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference"  class="cell-link">{{ scope.row.goalTime }}</span>
          </el-popover>
          <span v-else >{{ scope.row.goalTime ||'-'}}</span>
        </template>
        <template v-slot:expand="scope">
          <!-- siteList -->
          <custom-table index tableCode="locationSite_ft" :data="scope.row.siteList" @filter="filterChange" @sort="sortChange" height="300px" @column="setColumn" :slots="['deviceNum','goalArea','action']">
            <template v-slot:deviceNum="scope">
              <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
              <span v-else type="text">{{ scope.row.deviceNum }}</span>
            </template>
            <template v-slot:goalArea="scope">
              <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
            </template>
            <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
            <template v-slot:action="scope">
              <!-- v-if="funcView.location_device" -->
              <el-button  type="text" size="mini" @click="onDevice(scope.row)">{{ $t('dms_location.cha_kan_she_bei')}}</el-button>
              <!-- 更多操作 -->
              <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreSiteAction">
                <el-button type="text" size="mini">
                  <span>{{ $t('Common.com_more_action') }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- v-if="funcView.project_area_edit" -->
                  <el-dropdown-item  @click.native="editSite(scope.row)">{{ $t('Common.com_edit') }}{{ showMoreSite(scope.row) }}</el-dropdown-item>
                  <!-- v-if="funcView.project_area_delete" -->
                  <el-dropdown-item v-if="+scope.row.deviceNum===0" @click.native="delSite(scope.row)">{{ $t('Common.com_delete') }}{{ showMoreSite(scope.row) }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </custom-table>
        </template>
        <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
        <template v-slot:action="scope">
          <el-button v-if="funcView.location_device"  type="text" size="mini" @click="onDevice(scope.row)">{{ $t('dms_location.cha_kan_she_bei') }}</el-button>
          <!-- <el-button v-if="funcView.project_area_add && scope.row.isOwner" type="text" size="mini" @click="addSite(scope.row)">{{ funcView.project_area_add }}</el-button>
          <el-button v-if="funcView.project_edit && scope.row.isOwner" type="text" size="mini" @click="editProject(scope.row)">{{ funcView.project_edit }}</el-button>
          <el-button v-if="funcView.project_delete && scope.row.isOwner" type="text" size="mini" @click="delProject(scope.row)">{{ funcView.project_delete }}</el-button> -->
          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="funcView.project_area_add" @click.native="addSite(scope.row)">{{ $t('dms_location.tian_jia_qu_yu') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item v-if="funcView.project_edit" @click.native="editProject(scope.row)">{{ $t('Common.com_edit') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item @click.native="delProject(scope.row)"  v-if="funcView.project_delete && +scope.row.deviceNum===0">{{ $t('Common.com_delete') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item v-if="funcView.location_plan_add" @click.native="addPlan(scope.row)">{{ $t('dms_location.pai_ban_ji_hua') }}{{ showMore(scope.row) }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table-expand>
      <custom-table-expand
       type="checkbox"
       v-else
        v-model="tableSelect"
        :rowId="getRowKeys"
        tableCode="locationManage"
        :data="locationList"
        @filter="filterChange"
        :filterArr="timeZoneList.length>1?[]:['timeZoneRegionDesc']"
        @sort="sortChange"
        height="100%"
        @column="setColumn"
        :slots="['expand', 'deviceNum', 'goalArea','goalTime','detailAddress', 'action']"
        index
        @exChange="exChange"
        expand-row-keys
        expand
        :expandsKeyList="expands"
      >
        <template v-slot:deviceNum="scope">
          <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
          <span v-else type="text">{{ scope.row.deviceNum }}</span>
        </template>
        <template v-slot:goalArea="scope">
          <el-popover placement="bottom" width="610" trigger="hover" v-if="+scope.row.goalArea>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
            <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
              <el-table-column width="100" property="productCode" :label="$t('dms_location.chan_pin_xing_hao')"></el-table-column>
              <el-table-column width="70" property="deviceNum" :label="$t('dms_location.she_bei_shu_liang')"></el-table-column>
              <el-table-column width="100" property="basicArea" :label="$t('dms_location.xttjqjmjmt')"></el-table-column>
              <el-table-column width="100" property="basicTime" :label="$t('dms_location.xttjqjscmint')"></el-table-column>
              <el-table-column width="100" property="totalGoalArea" :label="$t('dms_location.xjqjmjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="totalGoalTime" :label="$t('dms_location.xjqjscmint')">
                <template slot-scope="scope">
                  <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference" class="cell-link">{{ $formatLenLocal(scope.row.goalArea) }}</span>
          </el-popover>
          <span  v-else >{{$formatLenLocal(scope.row.goalArea)}}</span>
        </template>
        <template v-slot:goalTime="scope">
          <el-popover placement="bottom" width="610" trigger="hover" v-if="+scope.row.goalTime>0&&+scope.row.isBasicGoal === 1&&scope.row.basicGoalDetailList">
            <el-table :data="scope.row.basicGoalDetailList" :summary-method="summaryMethod" show-summary>
              <el-table-column width="100" property="productCode" :label="$t('dms_location.chan_pin_xing_hao')"></el-table-column>
              <el-table-column width="70" property="deviceNum" :label="$t('dms_location.she_bei_shu_liang')"></el-table-column>
              <el-table-column width="100" property="basicArea" :label="$t('dms_location.xttjqjmjmt')"></el-table-column>
              <el-table-column width="100" property="basicTime" :label="$t('dms_location.xttjqjscmint')"></el-table-column>
              <el-table-column width="100" property="totalGoalArea" :label="$t('dms_location.xjqjmjftt')">
                <template slot-scope="scope">
                  <span size="mini">{{+scope.row.basicArea>0?formatNumber((+scope.row.deviceNum * $formatLenLocal(+scope.row.basicArea)).toFixed(2)):0}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" property="totalGoalTime" :label="$t('dms_location.xjqjscmint')">
                <template slot-scope="scope">
                  <span size="mini">{{( +scope.row.basicTime>0?formatNumber((+scope.row.deviceNum * +scope.row.basicTime).toFixed(2)):0)}}</span>
                </template>
              </el-table-column>
            </el-table>
            <span slot="reference" class="cell-link">{{ scope.row.goalTime }}</span>
          </el-popover>
          <span v-else >{{ scope.row.goalTime ||'-'}}</span>
        </template>
        <template v-slot:expand="scope">
          <!-- siteList -->
          <custom-table index tableCode="locationSite" :data="scope.row.siteList" @filter="filterChange" @sort="sortChange" height="300px" @column="setColumn" :slots="['deviceNum', 'goalArea','action']">
            <template v-slot:deviceNum="scope">
              <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
              <span v-else type="text">{{ scope.row.deviceNum }}</span>
            </template>
            <template v-slot:goalArea="scope">
              <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
            </template>
            <template v-slot:action="scope">
              <!-- v-if="funcView.location_device" -->
              <el-button  type="text" size="mini" @click="onDevice(scope.row)">{{ $t('dms_location.cha_kan_she_bei')}}</el-button>
              <!-- 更多操作 -->
              <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreSiteAction">
                <el-button type="text" size="mini">
                  <span>{{ $t('Common.com_more_action') }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- v-if="funcView.project_area_edit" -->
                  <el-dropdown-item  @click.native="editSite(scope.row)">{{ $t('Common.com_edit') }}{{ showMoreSite(scope.row) }}</el-dropdown-item>
                  <!-- v-if="funcView.project_area_delete" -->
                  <el-dropdown-item  @click.native="delSite(scope.row)" v-if="+scope.row.deviceNum===0">{{ $t('Common.com_delete') }}{{ showMoreSite(scope.row) }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </custom-table>
        </template>
        <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
        <template v-slot:action="scope">
          <el-button v-if="funcView.location_device" type="text" size="mini" @click="onDevice(scope.row)">{{ $t('dms_location.cha_kan_she_bei') }}</el-button>
          <!-- <el-button v-if="funcView.project_area_add && scope.row.isOwner" type="text" size="mini" @click="addSite(scope.row)">{{ funcView.project_area_add }}</el-button>
          <el-button v-if="funcView.project_edit && scope.row.isOwner" type="text" size="mini" @click="editProject(scope.row)">{{ funcView.project_edit }}</el-button>
          <el-button v-if="funcView.project_delete && scope.row.isOwner" type="text" size="mini" @click="delProject(scope.row)">{{ funcView.project_delete }}</el-button> -->
          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="funcView.project_area_add" @click.native="addSite(scope.row)">{{ $t('dms_location.tian_jia_qu_yu') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item v-if="funcView.project_edit" @click.native="editProject(scope.row)">{{ $t('Common.com_edit') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item v-if="funcView.project_delete && +scope.row.deviceNum===0" @click.native="delProject(scope.row)">{{ $t('Common.com_delete') }}{{ showMore(scope.row) }}</el-dropdown-item>
              <el-dropdown-item v-if="funcView.location_plan_add" @click.native="addPlan(scope.row)">{{ $t('dms_location.pai_ban_ji_hua') }}{{ showMore(scope.row) }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table-expand>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- </div> -->
    <project-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onItemChange"></project-item-dialog>
    <project-site-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></project-site-dialog>
    <project-floor-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="getTableList"></project-floor-dialog>
    <project-selectDevice-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false" @success="getTableList"></project-selectDevice-dialog>
    <location-timeZone-dialog v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false" @success="getTableList"></location-timeZone-dialog>
    <location-plan-dialog v-if="dialogVisible6" :model="dialogModel6" @close="dialogVisible6 = false" @success="getTableList"></location-plan-dialog>
    <!-- <organ-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getProjectTree"></organ-dialog> -->
  </div>
</template>

<script>
import apis from '@/utils/apis';

// import organDialog from '@/pages/base/components/organDialog.vue';

// import projectItemDialog from './children/project_item_dialog.vue';
import customTableExpand from '@/components/customTableExpand.vue';
import projectItemDialog from '@/components/addProjectDialog.vue';
import projectSiteDialog from '@/pages/dms/components/project_site_dialog.vue';
import projectFloorDialog from '@/pages/dms/components/project_floor_dialog.vue';
import projectSelectDeviceDialog from './project_selectDevice_dialog.vue';
import locationTimeZoneDialog from './location_timeZone_dialog.vue';
import locationPlanDialog from './location_plan_dialog';

export default {
  name: 'project',
  components: {
    projectItemDialog,
    projectFloorDialog,
    projectSiteDialog,
    projectSelectDeviceDialog,
    customTableExpand,
    locationTimeZoneDialog,
    locationPlanDialog
  },
  data() {
    return {
      tableSelect: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.locationId;
      },
      appKey: '',
      locationList: [],
      siteList: [],
      row: {},
      projectData: {},
      infoDataList: [],
      dialogVisible: false,
      dialogModel: {},
      // dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      dialogVisible4: false,
      dialogModel4: {},
      dialogVisible5: false,
      dialogModel5: {},
      dialogVisible6: false,
      dialogModel6: {},

      organUserList: [],
      totalRows: 0,
      childrenCount: 0,
      totalCount: 0,
      isLoading: false,

      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        gmtCreate: [],
        gmtStartTime: '',
        gmtEndTime: '',
        orgName: '',
        tagName: ''
      },
      link: null,
      expands: [],
      timeZoneList: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    // 使用 computed 判断是否存在 isBasicGoal 为 true 的项
    hasBasicGoal() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '1');
    },
    hasNoBasicGoa() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '0');
    }
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
    this.getTimeZoneList();
  },
  methods: {
    // 自定义汇总方法
    summaryMethod({ columns, data }) {
      const sums = [];
      // 第一列，总计
      sums[0] = this.$t('dms_location.zong_ji');
      // 第二列，deviceNum 的合计
      sums[1] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0), 0));
      // 第四列，deviceNum * basicArea 的合计
      sums[4] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0) * (Number(this.$formatLenLocal(row.basicArea)) || 0), 0));
      // 第五列，deviceNum * basicTime 的合计
      sums[5] = this.formatNumber(data.reduce((sum, row) => sum + (Number(row.deviceNum) || 0) * (Number(row.basicTime) || 0), 0));

      // 返回汇总行
      columns.forEach((column, index) => {
        if (index !== 0 && index !== 1 && index !== 4 && index !== 5) {
          sums[index] = ''; // 对其他列为空
        }
      });

      return sums;
    },

    // 格式化数字，判断是否保留两位小数
    formatNumber(number) {
      return number % 1 === 0 ? number : number.toFixed(2);
    },

    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    showMoreSite: function (row) {
      // row.showMoreSiteAction = true;
      this.$set(row, 'showMoreSiteAction', true);
      return '';
    },
    onItemChange(item) {
      if (`${item.isBasicGoal}` === '1' && this.funcView.project_update_targets) {
        this.$postJSON(apis.locationBasicGoalRefresh, [item.locationId]).then(() => {
          this.onPageChange({ page: 1 });
        });
      } else {
        this.getTableList();
      }
    },
    getTableList: function () {
      this.formSearch.gmtStartTime = this.formSearch.gmtCreate && this.formSearch.gmtCreate[0] ? this.formSearch.gmtCreate[0] : undefined;
      this.formSearch.gmtEndTime = this.formSearch.gmtCreate && this.formSearch.gmtCreate[1] ? this.formSearch.gmtCreate[1] : undefined;
      this.$getJSON(apis.locationBizPage, this.formSearch).then((res) => {
        const locationList = res.data.list || [];
        locationList.forEach((item) => {
          item.siteList = [];
        });
        this.locationList = locationList;
        this.totalRows = res.data.total;

        this.$nextTick(() => {
          if (this.row.locationId) {
            const index = this.locationList.findIndex(item => item.locationId === this.row.locationId);
            if (index !== -1) {
              this.exChange(this.locationList[index]);
            }
          }
        });

      });
    },
    // 获取info详情列表
    getInfoDataList: function () {
      let api = '';
      let params = '';
      if (`${this.projectData.type}` === '1') {
        api = apis.locationInfo;
        params = {
          locationId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else if (`${this.projectData.type}` === '2') {
        api = apis.locationFloorInfo;
        params = {
          floorId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else if (`${this.projectData.type}` === '3') {
        api = apis.locationSiteInfo;
        params = {
          siteId: this.projectData.id,
        };
        this.$getJSON(api, params).then((res) => {
          this.infoDataList = [res.data] || [];
        });
      } else {
        // tree无数据时显示组织名称  创建组织
        this.infoDataList = [
          {
            orgName: this.userInfo.rootOrgName,
          },
        ];
      }
    },

    // 添加项目
    addProject: function () {
      const title = this.$t('dms_location.tian_jia_xiang_mu');
      this.dialogModel.type = 'add';
      this.dialogModel.title = title;
      this.dialogModel.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
      };
      this.dialogVisible = true;
    },

    addSite: function (data) {
      const title = this.$t('dms_location.tian_jia_qu_yu');
      this.dialogModel2.type = 'add';
      this.dialogModel2.title = title;
      this.dialogModel2.data = data;
      this.dialogVisible2 = true;
    },
    // 添加项目
    addFloor: function (data) {
      const title = this.$t('dms_location.tjqybq');
      this.dialogModel3.type = 'add';
      this.dialogModel3.title = title;
      this.dialogModel3.data = data;
      this.dialogVisible3 = true;
    },
    // 添加计划
    addPlan: function (data) {
      const title = this.$t('dms_location.xin_zeng_ji_huao', [data.locationName]);
      this.dialogModel6.type = 'add';
      this.dialogModel6.title = title;
      this.dialogModel6.data = data;
      this.dialogVisible6 = true;
    },

    editProject(data) {
      const title = this.$t('dms_location.bian_ji_xiang_mu');
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogModel.id = data.locationId;
      this.dialogModel.data = {
        orgId: this.userInfo.rootOrgId,
        orgName: this.userInfo.rootOrgName,
        ...data,
      };
      this.dialogVisible = true;
    },
    editFloor(data) {
      const title = this.$t('dms_location.bjqybq');
      this.dialogModel3.type = 'edit';
      this.dialogModel3.title = title;
      this.dialogModel3.data = data;
      this.dialogVisible3 = true;
    },
    editSite(data) {
      const title = this.$t('dms_location.bian_ji_qu_yu');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.title = title;
      this.dialogModel2.data = data;
      this.dialogVisible2 = true;
    },
    delProject: function (data) {
      const title = this.$t('dms_location.nqdysccxmm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationDelete}/${data.locationId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    delFloor: function (data) {
      const title = this.$t('dms_location.nqdysccqybqm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationFloorDelete}/${data.id}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    delSite: function (row) {
      const title = this.$t('dms_location.nqdysccqym');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationSiteDelete}/${row.siteId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getSiteList(this.row, row.locationId);
          });
        })
        .catch(() => {});
    },
    // 按推荐更新目标
    onUpdateTargets: function () {
      const title = this.$t('dms_location.nqdyaxttjmbzgxsxxmm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(apis.locationBasicGoalRefresh, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    // 启用目标自动设置
    onEnableTargets: function () {
      const title = this.$t('dms_location.nqdyqyzdgxmbzsxxmm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationBasicGoalAutoBatch}/1`, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    // 禁用目标自动设置
    onDisableTargets: function () {
      const title = this.$t('dms_location.nqdyjyzdgxmbzsxxmm');
      const ids = this.tableSelect.map(item => item.locationId);
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationBasicGoalAutoBatch}/0`, ids).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    onUpdateTimeZone() {
      this.dialogModel5.type = 'update';
      this.dialogModel5.title = this.$t('dms_location.plgxxmsq');
      this.dialogModel5.data = this.tableSelect;
      this.dialogVisible5 = true;
    },
    // 关联用户弹窗
    bindDevice: function () {
      const title = this.$t('dms_location.bang_ding_she_bei');
      this.dialogModel4.title = title;
      this.dialogModel4.data = this.projectData;
      this.dialogVisible4 = true;
    },
    // 获取部门用户列表
    getDeviceList: function () {
      this.formSearch.locationId = '';
      this.formSearch.floorId = '';
      this.formSearch.siteId = '';
      if (`${this.projectData.type}` === '1') {
        this.formSearch.locationId = this.projectData.id;
      } else if (`${this.projectData.type}` === '2') {
        this.formSearch.floorId = this.projectData.id;
      } else if (`${this.projectData.type}` === '3') {
        this.formSearch.siteId = this.projectData.id;
      }

      this.isLoading = true;
      this.$getJSON(apis.locationDevicePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.organUserList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取时区列表
    getTimeZoneList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
      });
    },
    // 展开
    exChange: function (row) {
      this.expands = [];
      this.expands.push(row.locationId);
      this.row = row;
      row.siteList = [];
      this.getSiteList(row, row.locationId);
    },
    // 获取零件变更图片
    getSiteList: function (row, locationId) {
      if (locationId) {
        this.$getJSON(apis.locationSiteAllList, {
          locationId: locationId,
        }).then((res) => {
          row.siteList = res.data || [];
          this.$set(row, 'siteList', res.data);
        });
      }

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    onDevice: function (row) {
      let title = '';
      if (row.siteName) {
        title = this.$t('dms_location.cha_kanooshe_bei', [this.row.locationName || row.locationName,row.siteName]);
      } else {
        title = this.$t('dms_location.cha_kanoshe_bei', [this.row.locationName || row.locationName]);
      }
      this.dialogModel4.title = title;
      this.dialogModel4.locationId = row.locationId;
      this.dialogModel4.locationName = this.row.locationName || row.locationName;
      this.dialogModel4.siteId = row.siteId;
      this.dialogModel4.data = row;
      this.dialogVisible4 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.location-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
}
</style>
